import styled from 'styled-components'

type Props = {
	size: number
	isRounded?: boolean
}

export const Image = styled.img<Props>`
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
	object-fit: scale-down;
	display: inline-block;
	vertical-align: middle;
	flex-shrink: 0;

	border-radius: ${({ size, isRounded }) => (isRounded ? size / 2 : null)}px;
`
